import { Box, Stack, Typography } from '@mui/material'
import { blue } from '@mui/material/colors'
import { useEffect, useState } from 'react'

const NAVY = '#14233a'
const BABY_BLUE = blue[300]
const SPLASH_DURATION = 2200

const letters = [
  { char: 'D', color: BABY_BLUE },
  { char: 'E', color: '#fff' },
  { char: 'V', color: '#fff' },
  { char: 'H', color: '#fff' },
  { char: 'U', color: '#fff' },
  { char: 'B', color: '#fff' },
]

const LETTER_STAGGER = 100
const LAST_LETTER_DELAY = (letters.length - 1) * LETTER_STAGGER

export const SPLASH_SEEN_KEY = 'devhubSplashSeen'

interface SplashScreenProps {
  onComplete: () => void
}

export const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [fadingOut, setFadingOut] = useState(false)

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadingOut(true), SPLASH_DURATION - 500)
    const removeTimer = setTimeout(onComplete, SPLASH_DURATION)
    return () => {
      clearTimeout(fadeTimer)
      clearTimeout(removeTimer)
    }
  }, [onComplete])

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: NAVY,
        opacity: fadingOut ? 0 : 1,
        transition: 'opacity 0.5s ease-out',
        '@keyframes fadeUp': {
          '0%': { opacity: 0, transform: 'translateY(24px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          fontFamily: '"Quicksand", "Inter", sans-serif',
          fontWeight: 800,
          fontSize: { xs: '3.5rem', sm: '5rem', md: '7rem' },
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          userSelect: 'none',
        }}
      >
        {letters.map((l, i) => (
          <Box
            key={i}
            component="span"
            sx={{
              color: l.color,
              opacity: 0,
              animation: `fadeUp 0.4s ease-out ${i * LETTER_STAGGER}ms forwards`,
            }}
          >
            {l.char}
          </Box>
        ))}
      </Box>

      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{
          position: 'absolute',
          bottom: { xs: 32, md: 48 },
          opacity: 0,
          animation: `fadeUp 0.6s ease-out ${LAST_LETTER_DELAY + 200}ms forwards`,
          '@keyframes fadeUp': {
            '0%': { opacity: 0, transform: 'translateY(12px)' },
            '100%': { opacity: 0.4, transform: 'translateY(0)' },
          },
        }}
      >
        <Typography
          component="span"
          sx={{
            color: '#fff',
            fontSize: { xs: '0.7rem', md: '0.8rem' },
            fontWeight: 500,
            letterSpacing: '0.12em',
            textTransform: 'lowercase',
          }}
        >
          by
        </Typography>
        <Box
          component="img"
          src="/images/iFinance-white.svg"
          alt="iFinance"
          sx={{ height: { xs: 14, md: 18 } }}
        />
      </Stack>
    </Box>
  )
}
